import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["disableCursor", "content"],
      _excluded2 = ["classes", "noCursor", "style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { AccordionSummary as MuiExpansionPanelSummary } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

/** @component */
export const ExpansionPanelSummary = withStyles(theme => ({
  root: {
    padding: 0,
    borderBottom: `1px solid ${theme.palette.background.paper}`,
    minHeight: 30,
    '&$expanded': {
      borderBottom: 0,
      marginBottom: 0,
      minHeight: 30
    }
  },
  content: {
    margin: 0,
    minHeight: 30,
    '&$expanded': {
      minHeight: 30,
      margin: 0
    }
  },
  disableCursor: {
    cursor: 'default'
  },
  expanded: {}
}))(_ref => {
  let {
    classes: {
      disableCursor,
      content
    },
    noCursor,
    style
  } = _ref,
      classes = _objectWithoutProperties(_ref.classes, _excluded),
      props = _objectWithoutProperties(_ref, _excluded2);

  return /*#__PURE__*/React.createElement(MuiExpansionPanelSummary, _extends({
    classes: _objectSpread({
      content: noCursor ? `${disableCursor} ${content}` : content
    }, classes),
    style: style
  }, props));
});
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
// @ts-ignore

ExpansionPanelSummary.muiName = 'ExpansionPanelSummary';
export default ExpansionPanelSummary;